//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "CooperativeTransfer",
};
